"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = getIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var styles = {
  "header": "header_3stP4D",
  "item": "item_2Lgj-5",
  "hierarchy-2": "hierarchy-2_1G9wOz",
  "hierarchy2": "hierarchy-2_1G9wOz",
  "active": "active_3u2LpW",
  "content": "content_3F7i8X",
  "label": "label_jpQx30",
  "annotation": "annotation_20x4VE",
  "item-move": "item-move_3Ba0qn",
  "itemMove": "item-move_3Ba0qn",
  "hidden": "hidden_3Rmit_",
  "open-icon": "open-icon_1M0HPq",
  "openIcon": "open-icon_1M0HPq",
  "icon": "icon_J-WQsp",
  "error": "error_3327M8",
  "suffix": "suffix_2lvjBy",
  "disabled": "disabled_3yRSJM"
}; 
require('./SidebarItem.css');
function getIcon(icon) {
  if (!icon) {
    return null;
  }
  var iconProps = {
    'data-test-id': 'link-icon',
    size: 'xs',
    className: styles.icon,
    role: 'presentation'
  };
  if (/*#__PURE__*/_react.default.isValidElement(icon)) {
    return /*#__PURE__*/_react.default.createElement(_Icon.default, iconProps, icon);
  }
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, iconProps, {
    name: icon === null || icon === void 0 ? void 0 : icon.id,
    isExternal: icon.isExternal || false
  }));
}
//# sourceMappingURL=utils.js.map